import type { ReactElement } from 'react';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { EntityCellProps } from '../../../../../model/index.tsx';
import { isPrivate } from '../../../../../state/selectors/boards/index.tsx';
import type { State } from '../../../../../state/types.tsx';
import PublicVsPrivateSwitchCell from './view.tsx';

export type Props = {
	children: (arg1: { isPrivate: boolean }) => ReactElement;
} & EntityCellProps;

const mapStateToProps = () => (state: State, ownProps: Props) => ({
	isPrivate: isPrivate(state, ownProps.id),
});

export default connect(mapStateToProps, {})(PublicVsPrivateSwitchCell);
